/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateRecordingEnvelopePayload } from './CreateRecordingEnvelopePayload';
import {
    CreateRecordingEnvelopePayloadFromJSON,
    CreateRecordingEnvelopePayloadFromJSONTyped,
    CreateRecordingEnvelopePayloadToJSON,
} from './CreateRecordingEnvelopePayload';

/**
 * 
 * @export
 * @interface CreateRecordingEnvelope
 */
export interface CreateRecordingEnvelope {
    /**
     * 
     * @type {CreateRecordingEnvelopePayload}
     * @memberof CreateRecordingEnvelope
     */
    payload: CreateRecordingEnvelopePayload;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelope
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelope
     */
    westburyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelope
     */
    eventTime?: string;
}

/**
 * Check if a given object implements the CreateRecordingEnvelope interface.
 */
export function instanceOfCreateRecordingEnvelope(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payload" in value;

    return isInstance;
}

export function CreateRecordingEnvelopeFromJSON(json: any): CreateRecordingEnvelope {
    return CreateRecordingEnvelopeFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelope {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payload': CreateRecordingEnvelopePayloadFromJSON(json['payload']),
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'westburyId': !exists(json, 'westbury_id') ? undefined : json['westbury_id'],
        'eventTime': !exists(json, 'event_time') ? undefined : json['event_time'],
    };
}

export function CreateRecordingEnvelopeToJSON(value?: CreateRecordingEnvelope | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payload': CreateRecordingEnvelopePayloadToJSON(value.payload),
        'user_id': value.userId,
        'westbury_id': value.westburyId,
        'event_time': value.eventTime,
    };
}

